/**
 * De modellenkolom rechts in de Easy-stand van Chats (02-10-2026, Jordy).
 *
 * Eén regel per model-slug (dezelfde tegels als de Pro-stand, zie
 * lib/modelTegels.ts). Klik op een model en de gesprekkenlijst links toont
 * alleen dat model; "All" haalt het filter weg. Het getal is het aantal
 * gesprekken van dat model in het filter dat links aan staat.
 */
import { Avatar, Plat } from './ui'
import type { ModelTegel } from '../lib/modelTegels'

export function ModelLijst({ tegels, aantallen, totaal, gekozen, onKies }: {
  tegels: ModelTegel[]
  /** Aantal gesprekken per slug in het actieve filter. */
  aantallen: Map<string, number>
  totaal: number
  /** De gekozen slug, of 'all'. */
  gekozen: string
  onKies: (slug: string) => void
}) {
  return (
    <div className="modellen" role="list">
      <button type="button" role="listitem"
              className={gekozen === 'all' ? 'modelrij on' : 'modelrij'}
              onClick={() => onKies('all')}>
        <span className="mrnaam">All</span>
        <span className="spacer" style={{ flex: 1 }} />
        {totaal ? <span className="mrtal">{totaal}</span> : null}
      </button>
      {tegels.map((t) => {
        const n = aantallen.get(t.slug) ?? 0
        return (
          <button type="button" role="listitem" key={t.key}
                  data-slug={t.slug}
                  className={gekozen === t.slug ? 'modelrij on' : 'modelrij'}
                  title={`${t.name} · ${t.chats} chats`}
                  onClick={() => onKies(t.slug)}>
            <Avatar name={t.name} src={t.avatar} size={26} />
            <span className="mrnaam">{t.name}</span>
            <Plat value={t.platform} />
            <span className="spacer" style={{ flex: 1 }} />
            {n ? <span className="mrtal">{n}</span> : null}
          </button>
        )
      })}
    </div>
  )
}
